import {Component} from '@angular/core';
import {defaultThemeDescriptions, ThemeDescription} from '../../models/theme-description';
import {UserSettingsService} from '../../services/user-settings.service';
import { PanelModule } from 'primeng/panel';

import { ButtonDirective } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';

@Component({
    selector: 'app-theme-chooser',
    styleUrls: ['./theme-chooser.component.scss'],
    templateUrl: './theme-chooser.component.html',
    imports: [
    PanelModule,
    ButtonDirective,
    TooltipModule
]
})
export class ThemeChooserComponent {

    themes: ThemeDescription[] = defaultThemeDescriptions.sort((a, b) =>
        (a.darkTheme ? 0 : 1) - (b.darkTheme ? 0 : 1) ||
        (a.darkTheme === b.darkTheme && a.id - b.id)
    );

    constructor(private userSettings: UserSettingsService) {
    }

    changeTheme(theme: ThemeDescription) {
        this.userSettings.setTheme(theme.id);
    }

    getTooltip(theme: ThemeDescription) {
        const luminosity = theme.darkTheme ? 'SCURO' : 'CHIARO';
        return `Tema ${luminosity}. Colore ${theme.name}`;
    }

}

